var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Widget',{attrs:{"title":_vm.$t('Flächennutzung')}},[_c('Table',{attrs:{"fixed":"","headerless":"","fields":_vm.tableFields,"items":_vm.tableItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }